"use strict";

let currentReview = 0;
let reviews;
let reviewInterval; // Variable to hold the interval reference

document.addEventListener("DOMContentLoaded", function () {
  const reviewContainer = document.querySelector(".review-container");
  if (!reviewContainer) {
    return;
  }
  reviews = document.querySelectorAll(".review-item");
  function calculateMaxHeight() {
    let maxHeight = 0;
    reviews.forEach(review => {
      review.style.display = "block"; // Temporarily display all reviews
      let reviewHeight = review.offsetHeight;
      if (reviewHeight > maxHeight) {
        maxHeight = reviewHeight;
      }
      review.style.display = ""; // Reset display style
    });
    reviewContainer.style.height = "".concat(maxHeight + 50, "px");
  }

  // Calculate the max height on load
  calculateMaxHeight();

  // Start the automatic review change
  startReviewInterval();
  showReview(currentReview); // Show the first review initially

  // Recalculate max height on window resize
  window.addEventListener("resize", calculateMaxHeight);
});
function startReviewInterval() {
  reviewInterval = setInterval(() => {
    currentReview = (currentReview + 1) % reviews.length;
    showReview(currentReview);
  }, 5000);
}
function resetReviewInterval() {
  clearInterval(reviewInterval); // Clear the existing interval
  startReviewInterval(); // Start a new interval
}
function reviewsScrollPrev() {
  currentReview = (currentReview - 1 + reviews.length) % reviews.length; // Ensure currentReview doesn't go negative
  showReview(currentReview);
  resetReviewInterval(); // Reset the timer
}
function reviewsScrollNext() {
  currentReview = (currentReview + 1) % reviews.length;
  showReview(currentReview);
  resetReviewInterval(); // Reset the timer
}
function showReview(index) {
  reviews.forEach((review, i) => {
    if (i === index) {
      review.classList.add("active");
    } else {
      review.classList.remove("active");
    }
  });
}
//# sourceMappingURL=reviewsScroll.js.map